"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
const removers_1 = require("@App/helpers/work-entities/removers");
const fields_validators_1 = require("@App/helpers/work-entities/fields-validators");
const contexts_1 = require("@App/contexts");
const publisher_side_bar_state_1 = require("@App/enum/publisher-side-bar-state");
const EditSimplePublisher_1 = __importDefault(require("@Components/WorkRegistrationSubs/EditSimplePublisher"));
const EditSimpleOriginalPublisher = () => {
    const { publisherStepStore, workStore, popupStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const editingOP = publisherStepStore.editingOP;
    const editOriginalPublisher = (publisher) => {
        const workDraftFromLocal = workStore.workDraftLocal;
        const editingOPId = editingOP.localId;
        if (!workDraftFromLocal || !editingOPId) {
            return;
        }
        const originalPublishers = workDraftFromLocal.originalPublishers;
        const indexOfOP = originalPublishers.map((op) => op.localId).indexOf(editingOPId);
        const updatedOriginalPublisher = {
            localId: editingOPId,
            publisherName: publisher.publisherName,
            ipiNumber: publisher.ipiNumber ? publisher.ipiNumber.padStart(11, '0') : null,
            publisherShare: editingOP.publisherShare,
            administratorPublishers: editingOP.administratorPublishers,
            writers: editingOP.writers,
        };
        const updatedOPArray = (0, removers_1.setItemToArrayByIndex)(originalPublishers, +indexOfOP, updatedOriginalPublisher);
        const updatedWorkDraft = Object.assign(Object.assign({}, workDraftFromLocal), { originalPublishers: updatedOPArray });
        workStore.setWorkDraftToLocal(updatedWorkDraft);
        popupStore.setPublisherSidebarState(publisher_side_bar_state_1.PublisherSideBarState.empty);
    };
    const validatePublisherName = (name) => (0, fields_validators_1.publisherNameInvalidCheck)(name) ? 'Max length 200 symbol. May not include multiple lines.' : '';
    return (react_1.default.createElement(EditSimplePublisher_1.default, { publisher: editingOP, title: "Edit Original Publisher", subtitle: "Enter the Publisher's details", editButtonText: "Edit Publisher", publisherNameText: "Publisher Name", validatePublisherName: validatePublisherName, returnPublisher: editOriginalPublisher }));
};
exports.default = (0, mobx_react_1.observer)(EditSimpleOriginalPublisher);
